import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ManageUsersPageRoutingModule } from './manage-users-routing.module';
import { ManageUsersPage } from './manage-users.page';
import { SharedModule } from '../../app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ManageUsersListSectionBaseComponent } from './components/manage-users-list-section/manage-users-list-section-base.component';
import { ManageUsersListSectionMobileComponent } from './components/manage-users-list-section/manage-users-list-section-mobile-component/manage-users-list-section-mobile.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ManageUsersListSectionExpandedViewModalComponent } from './components/manage-users-list-section/manage-users-list-section-expanded-view-modal/manage-users-list-section-expanded-view-modal.component';
import { ManageUsersListSectionDesktopComponent } from './components/manage-users-list-section/manage-users-list-section-desktop-component/manage-users-list-section-desktop.component';
import { ManageUsersListSectionTabletComponent } from './components/manage-users-list-section/manage-users-list-section-tablet-component/manage-users-list-section-tablet.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
    ManageUsersPageRoutingModule,
    ScrollingModule,
  ],
  declarations: [
    ManageUsersPage,
    ManageUsersListSectionBaseComponent,
    ManageUsersListSectionMobileComponent,
    ManageUsersListSectionDesktopComponent,
    ManageUsersListSectionTabletComponent,
    ManageUsersListSectionExpandedViewModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageUsersPageModule {}
